import { fetchConversations } from '../conversations/fetchConversations'

export const REMOVE_PARTICIPANT_BEGIN = 'REMOVE_PARTICIPANT_BEGIN'
export const REMOVE_PARTICIPANT_SUCCESS = 'REMOVE_PARTICIPANT_SUCCESS'
export const REMOVE_PARTICIPANT_FAILED = 'REMOVE_PARTICIPANT_FAILED'


const removeParticipantBegin =   (payload) => ({ type: REMOVE_PARTICIPANT_BEGIN, payload })
const removeParticipantSuccess = (payload) => ({ type: REMOVE_PARTICIPANT_SUCCESS, payload })
const removeParticipantFailed =  (payload) => ({ type: REMOVE_PARTICIPANT_FAILED, payload })

export const removeParticipant = (participant) => {
  return (dispatch, getState) => {
    const { currentConversation } = getState()
    dispatch(removeParticipantBegin())
    return $.ajax(`/api/staff/v1/conversations/${currentConversation.id}/opt_out.json`, {
      method: 'POST',
      data: { conversation: { participant_id: participant.id }}
    }).then((response)=>{
      dispatch(removeParticipantSuccess(response))
    }).fail(()=>removeParticipantFailed())
  }
}